const myNav = document.querySelector('.main-header');
let topbar = document.querySelector('.topbar');
const topbarHeight = topbar ? topbar.offsetHeight : 0

let lastelement = '';
if(window.globalVariables.templateSuffix == 'collection_list'){
  lastelement = document.querySelector('#section-product').lastElementChild
};

window.onscroll = function() {
  if(window.scrollY > myNav.offsetHeight + topbarHeight){
    myNav.classList.add('header-stick')
  }else{
    myNav.classList.remove('header-stick')
  }

  if(window.scrollY > myNav.offsetHeight + topbarHeight + 100){
    myNav.classList.add('header-transition')
  }else{
    myNav.classList.remove('header-transition')
  }

  if(window.scrollY > window.innerHeight){
    if(window.globalVariables.template == 'product'){document.body.classList.add('sticky-cart-show')}
    myNav.classList.add('header-sticky')
  }else{
    if(window.globalVariables.template == 'product'){document.body.classList.remove('sticky-cart-show')}
    myNav.classList.remove('header-sticky');
  }

  if(window.globalVariables.templateSuffix == 'collection_list'){
    let bounding = lastelement.getBoundingClientRect();
    let myElementHeight = lastelement.offsetHeight;
    let myElementWidth = lastelement.offsetWidth;

    // if (bounding.top >= -myElementHeight 
    //     && bounding.left >= -myElementWidth
    //     && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + myElementWidth
    //     && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + myElementHeight)
    if (bounding.top <= document.querySelector('.site-header').offsetHeight)
    {
      lastelement.querySelector('[data-fixed-background]').style.backgroundAttachment = 'inherit'
    } else {
      lastelement.querySelector('[data-fixed-background]').style.backgroundAttachment = ''
    }
    const sections = document.querySelectorAll( '.coll-prod-lists' );
    const scrollPos = document.documentElement.scrollTop || document.body.scrollTop;

    for ( let s in sections )
        if ( sections.hasOwnProperty( s ) && sections[ s ].offsetTop <= scrollPos ) {
        const id = sections[ s ].id;
        let el = document.querySelectorAll('.coll-stick-li')
        if(document.querySelectorAll('.active').length > 0){
            document.querySelector('.active').classList.remove( 'active' );
        }
        document.querySelector( `a[data-href*=${id}]` ).classList.add( 'active' );

        }
  }
  

}